export default "__VITE_ASSET__b4b0875f__"